import request from '@/utils/request'

// 专题列表 
export function MoocSpecialLoad(params) {
    return request({
        url: '/api/MoocSpecial/Load',
        method: 'get',
        params
    })
}

// 专题详情
export function MoocSpecialGet(params) {
    return request({
        url: '/api/MoocSpecial/Get',
        method: 'get',
        params
    })
}

// 专题课程
export function MoocSpecialGetCourseList(params) {
    return request({
        url: '/api/MoocSpecial/GetCourseList',
        method: 'get',
        params
    })
}